import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { Check, Info } from "lucide-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  declineAup,
  recordAupAcceptance,
} from "slices/aupAcceptance/aupAcceptanceSlice";

import styles from "./AupAcceptanceModal.module.scss";

const TITLE = "System Use Notification";
const INTRO =
  "You are accessing an information system provided by VisibleThread that contains U.S. Government data. By accessing this system you acknowledge and agree that:";
const BULLETS = [
  "This system is provided for authorized use only.",
  "System usage may be monitored, recorded, and subject to audit. You have no reasonable expectation of privacy regarding any use of this system.",
  "Unauthorized use of the system is prohibited and may subject you to criminal and civil penalties.",
  "Use of the system indicates your consent to monitoring and recording.",
];
const FOOTER_NOTICE =
  'By selecting "I Accept", you acknowledge that you have read, understand, and agree to abide by VisibleThread\'s Rules of Behavior and these conditions of use. If you do not agree, select "Decline" and you will not be granted access.';

const AupAcceptanceModal = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((s) => s.aupAcceptance?.isLoading);

  const handleAccept = async () => {
    await dispatch(recordAupAcceptance()).unwrap();
  };

  const handleDecline = () => {
    dispatch(declineAup());
  };

  return (
    <Modal show centered backdrop onDismiss={() => {}}>
      {/* Custom header without passing onDismiss to avoid the X close button
          that Modal.Header renders when onDismiss is present */}
      <div className={styles.header}>
        <b>{TITLE}</b>
      </div>
      <Modal.Body>
        <div className={styles.body}>
          <p className={styles.intro}>{INTRO}</p>
          <ul className={styles.bullets}>
            {BULLETS.map((text) => (
              <li key={text}>
                <Check className={styles.checkIcon} aria-hidden="true" />
                <span>{text}</span>
              </li>
            ))}
          </ul>
          <div className={styles.notice}>
            <Info className={styles.noticeIcon} aria-hidden="true" />
            <span>{FOOTER_NOTICE}</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={styles.actions}>
          <NewButton
            variant={NewButtonVariant.l2}
            onClick={handleDecline}
            disabled={isLoading}
          >
            Decline
          </NewButton>
          <NewButton
            variant={NewButtonVariant.l1}
            onClick={handleAccept}
            disabled={isLoading}
          >
            I Accept
          </NewButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AupAcceptanceModal;
